<template>
	<div class="new-acc-container">
		<!-- 主体内容区 -->
		<div class="main-content-area">
			<!-- 左侧树菜单 -->
			<div class="department-nav">
				<!-- 修改左侧添加按钮 -->
				<div class="nav-header">
					<span>人员档案列表</span>
					<!-- 有权限时显示正常按钮 -->
					<el-tooltip v-if="$store.getters.hasPermission('system:staff:add')" content="添加人员档案列表"
						placement="top">
						<el-button type="text" size="mini" icon="el-icon-adds" class="add-btn"
							@click="handleAddPerson"></el-button>
					</el-tooltip>
					<!-- 无权限时显示禁用按钮 -->
					<el-tooltip v-else content="您当前暂无添加人员档案操作的权限，如需使用，请联系管理员。" placement="top">
						<el-button type="text" size="mini" icon="el-icon-adds" class="add-btn add-btn-disabled"
							disabled></el-button>
					</el-tooltip>
				</div>
				<el-tree :data="departmentTree" :props="treeProps" node-key="id" default-expand-all
					:highlight-current="true" :expand-on-click-node="false" @node-click="handleStatusClick">
					<span class="custom-tree-node" slot-scope="{ node, data }">
						<i :class="data.icon" class="tree-icon"
							:style="data.id === 2 ? {color: '#07c160'} : (data.id === 3 ? {color: '#f56c6c'} : {})"></i>
						<span>{{ node.label }}</span>
						<span class="dept-count" v-if="data.count > 0">{{ data.count }}</span>
					</span>
				</el-tree>
			</div>

			<!-- 右侧数据表格 -->
			<div class="data-table-area">
				<!-- 表格上方的查询条件 -->
				<div class="table-filter-area">
					<div class="filter-group">
						<el-select v-model="status" placeholder="状态" size="mini" class="filter-select"
							@change="handleStatusChange" clearable>
							<el-option v-for="item in statusOptions" :key="item.id" :label="item.label"
								:value="item.id"></el-option>
						</el-select>

						<!-- 在模板中修改el-autocomplete组件 -->
						<el-autocomplete v-model="searchName" :fetch-suggestions="querySearchAsync" placeholder="请输入姓名"
							size="mini" class="search-input" :trigger-on-focus="true" @select="handleSelectSuggestion"
							@clear="handleClearSearch" clearable :highlight-first-item="true">
							<template slot-scope="{ item }">
								<div v-html="highlightMatch(item.value, searchName)"></div>
							</template>
						</el-autocomplete>

						<el-button type="primary" size="mini" icon="el-icon-Ssearch" @click="handleSearch">
							查询
						</el-button>
						<el-button v-if="$store.getters.hasPermission('system:staff:add')" type="success" size="mini"
							icon="el-icon-adds" @click="handleAddPerson">
							添加人员
						</el-button>
						<el-button type="warning" size="mini" icon="el-icon-refresh" @click="handleReset">
							重置
						</el-button>
					</div>
				</div>

				<!-- 数据表格 -->
				<div class="table-container">
					<el-table :data="personList" style="width: 100%" :height="tableHeight"
						:row-class-name="tableRowClassName"
						:header-cell-style="{ background: '#f5f7fa', color: '#303133' }" stripe border size="mini">
						<!-- 修改表格列定义，移除密码图标，添加tooltip提示 -->
						<el-table-column label="序号" width="80" align="center" show-overflow-tooltip>
							<template slot-scope="scope">
								<span v-if="currentUserId && scope.row.id === currentUserId"
									style="display:flex;align-items:center;justify-content:center;position:relative;"
									class="current-user-mark">
									{{ (pagination.pageNum - 1) * pagination.pageSize + scope.$index + 1 }}
									<!-- 修改tooltip提示内容 -->
									<el-tooltip placement="top" effect="light" popper-class="password-tooltip-popper">
										<!-- 修改为忘记密码提示 -->
										<span slot="content" class="tooltip-content" @click.stop>
											<span
												style="display:block;font-size:12px;color:#606266;margin-bottom:4px;">忘记密码？</span>
											<el-link type="primary" :underline="false"
												@click="handleResetPassword(scope.row)" style="font-size:12px;">
												点击此处重置密码至初始状态
											</el-link>
										</span>
										<!-- tooltip触发区域 -->
										<span style="color:#409eff;font-weight:bold;cursor:pointer;margin-left:4px;">
											（我）
										</span>
									</el-tooltip>
								</span>
								<span v-else>
									{{ (pagination.pageNum - 1) * pagination.pageSize + scope.$index + 1 }}
								</span>
							</template>
						</el-table-column>
						<el-table-column prop="fullName" label="姓名" min-width="150" align="center"
							show-overflow-tooltip>
							<template slot-scope="scope">
								<div class="name-cell">
									<el-avatar v-if="scope.row.workIdPhoto" :size="24" :src="scope.row.workIdPhoto"
										class="avatar"></el-avatar>
									<el-avatar v-else :size="24"
										:style="{ backgroundColor: getRandomColor(scope.row.id) }" class="avatar">
										{{ scope.row.fullName ? scope.row.fullName.charAt(0) : '' }}
									</el-avatar>
									<el-link type="primary" @click="handleNameClick(scope.row)" class="name-link"
										:underline="false">
										{{ scope.row.fullName }}
									</el-link>
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="sex" label="性别" width="80" align="center" show-overflow-tooltip>
							<template slot-scope="scope">
								<div class="gender-cell">
									<i v-if="scope.row.sex === 1" class="el-icon-male gender-icon male"></i>
									<i v-else-if="scope.row.sex === 2" class="el-icon-female gender-icon female"></i>
									<span>{{ scope.row.sex === 1 ? '男' : (scope.row.sex === 2 ? '女' : '') }}</span>
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="idNumber" label="身份证号" min-width="150" align="center"
							show-overflow-tooltip>
							<template slot-scope="scope">
								{{ scope.row.idNumber ? formatIdNumber(scope.row.idNumber) : '' }}
							</template>
						</el-table-column>
						<el-table-column prop="brdy" label="出生日期" width="100" align="center"
							show-overflow-tooltip></el-table-column>
						<el-table-column prop="contactNumber" label="联系电话" width="120" align="center"
							show-overflow-tooltip></el-table-column>
						<el-table-column prop="userCode" label="人员编号" width="120" align="center"
							show-overflow-tooltip></el-table-column>
						<el-table-column prop="minZu" label="民族" width="100" align="center" show-overflow-tooltip>
							<template slot-scope="scope">
								{{ getDictText('natyEntities', scope.row.minZu) }}
							</template>
						</el-table-column>
						<el-table-column prop="professionalTitle" label="专业职称" width="120" align="center"
							show-overflow-tooltip>
							<template slot-scope="scope">
								{{ getDictText('profttlEntities', scope.row.professionalTitle) }}
							</template>
						</el-table-column>
						<el-table-column prop="deptName" label="隶属科室" width="140" align="center"
							show-overflow-tooltip></el-table-column>
						<el-table-column prop="lunarBrdy" label="农历生日" width="100" align="center"
							show-overflow-tooltip></el-table-column>
						<el-table-column prop="politicsStatus" label="政治面貌" width="120" align="center"
							show-overflow-tooltip>
							<template slot-scope="scope">
								{{ getDictText('jobEntities', scope.row.politicsStatus) }}
							</template>
						</el-table-column>
						<el-table-column prop="bloodType" label="血型" width="80" align="center" show-overflow-tooltip>
							<template slot-scope="scope">
								{{ getDictText('aboTypeEntities', scope.row.bloodType) }}
							</template>
						</el-table-column>
						<!-- 修改表格操作列 -->
						<el-table-column label="操作" width="200" align="center" fixed="right">
							<template slot-scope="scope">
								<el-button type="info" size="mini" @click="handleView(scope.row)">
									档案详情
								</el-button>
								<el-button type="warning" size="mini" icon="el-icon-edit"
									@click="handleEdit(scope.row)">
									编辑档案
								</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>

				<!-- 分页控件 -->
				<div class="pagination-area left">
					<el-pagination :current-page="pagination.pageNum" :page-size="pagination.pageSize"
						:total="pagination.total" :page-sizes="[15, 20, 30, 50]"
						layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
						@current-change="handleCurrentChange"></el-pagination>
				</div>
			</div>
		</div>

		<!-- 子组件模态框 -->
		<new-acc-son ref="newAccSon" :visible.sync="dialogVisible" :mode="dialogMode" :clinicName="clinicName"
			:selectedId="selectedId" @success="handleDialogSuccess" @close="dialogVisible = false" />
	</div>
</template>

<script>
	import {
		selectList,
		dict,
		updateStatus
	} from "@/api/staff/staff.js"
	import {
		GetUserInfo,
		roleList,
		updateUser
	} from "@/api/user.js"
	// 省市区员工等
	import {
		editPwd,
		loginOut,
		findAttribute,
		getArea,
		addStaff,
		updateStaff,
		getStaff,
		builderImage
	} from "@/api/user.js"

	// 导入子组件
	import NewAccSon from './NewAccSon.vue'

	export default {
		name: 'NewAcc',
		components: {
			NewAccSon
		},
		data() {
			return {
				// 筛选条件
				status: '',
				searchName: '',
				statusOptions: [{
						id: '',
						label: '全部'
					},
					{
						id: 1,
						label: '正常'
					},
					{
						id: 0,
						label: '异常'
					}
				],
				// 诊所名称
				clinicName: '人员档案列表',
				// 当前登录用户ID
				currentUserId: null,
				currentUserStaffName: '',
				// 当前编辑的用户
				currentEditUser: null,
				// 部门树数据
				departmentTree: [{
					id: 1,
					label: '人员档案列表',
					icon: 'el-icon-idKinds',
					count: 0,
					value: '',
					children: [{
							id: 2,
							label: '正常',
							icon: 'el-icon-success',
							count: 0,
							value: 1
						},
						{
							id: 3,
							label: '异常',
							icon: 'el-icon-warning',
							count: 0,
							value: 0
						}
					]
				}],
				treeProps: {
					children: 'children',
					label: 'label'
				},

				// 表格数据
				personList: [],

				// 表格高度
				tableHeight: null,

				// 分页
				pagination: {
					pageNum: 1,
					pageSize: 15,
					total: 0
				},

				// 字典数据
				dictData: {
					natyEntities: [],
					profttlEntities: [],
					jobEntities: [],
					aboTypeEntities: []
				},

				// 颜色缓存
				colorCache: {},

				// 模态框相关
				dialogVisible: false,
				dialogMode: 'add', // 'add', 'edit', 'view'
				selectedId: null,

				// 搜索提示数据缓存
				searchSuggestions: [],
				searchLoading: false
			}
		},
		mounted() {
			// 获取诊所名称
			this.getClinicName()

			// 获取当前登录用户信息
			this.getCurrentUserInfo()

			// 生成随机头像颜色缓存
			this.generateColorCache()

			// 获取字典数据
			this.fetchDictData()

			// 获取人员列表
			this.fetchPersonList()

			// 计算表格高度
			this.$nextTick(() => {
				this.calcTableHeight()
			})

			// 监听窗口大小变化
			window.addEventListener('resize', this.calcTableHeight)
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.calcTableHeight)
		},
		methods: {
			// 获取诊所名称
			getClinicName() {
				try {
					const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
					if (userInfo && userInfo.clinicName) {
						this.clinicName = userInfo.clinicName
						this.departmentTree[0].label = userInfo.clinicName
					}
				} catch (error) {
					console.error('获取诊所名称失败:', error)
				}
			},

			// 获取当前登录用户信息
			getCurrentUserInfo() {
				try {
					const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
					this.currentUserId = userInfo.staffId || null
					this.currentUserStaffName = userInfo.staffName || ''
				} catch (error) {
					console.error('获取当前用户信息失败:', error)
				}
			},

			// 高亮显示匹配的文本 - 优化为红色和加粗
			highlightMatch(text, query) {
				if (!text || !query || query.trim() === '') {
					return text
				}

				const lowerText = text.toLowerCase()
				const lowerQuery = query.toLowerCase()
				const index = lowerText.indexOf(lowerQuery)

				if (index === -1) {
					return text
				}

				// 找到所有匹配的位置
				const regex = new RegExp(`(${this.escapeRegExp(query)})`, 'gi')
				const highlightedText = text.replace(regex, '<span class="highlight-match-red">$1</span>')

				return highlightedText
			},

			// 获取人员列表 - 优化排序
			async fetchPersonList() {
				try {
					const params = {
						fullName: this.searchName,
						pageNum: this.pagination.pageNum,
						pageSize: this.pagination.pageSize,
						status: this.status
					}

					const res = await selectList(params)
					if (res && res.code === 200 && res.data) {
						let personList = res.data.content || []
						this.pagination.total = res.data.totalSize || 0

						// 将当前登录用户移到第一条
						if (this.currentUserId) {
							const currentUserIndex = personList.findIndex(item => item.id === this.currentUserId)
							if (currentUserIndex > 0) {
								const currentUser = personList.splice(currentUserIndex, 1)[0]
								personList.unshift(currentUser)
							} else if (currentUserIndex === -1 && this.currentUserStaffName) {
								// 如果当前用户不在列表中，尝试通过姓名匹配
								const nameMatchIndex = personList.findIndex(item =>
									item.fullName && item.fullName.includes(this.currentUserStaffName)
								)
								if (nameMatchIndex > 0) {
									const currentUser = personList.splice(nameMatchIndex, 1)[0]
									personList.unshift(currentUser)
								}
							}
						}

						this.personList = personList

						// 更新树菜单的计数
						this.updateTreeCounts(res.data)
					} else {
						this.personList = []
						this.pagination.total = 0
					}
				} catch (error) {
					console.error('获取人员列表失败:', error)
					this.personList = []
					this.pagination.total = 0
				}
			},

			// 监听密码输入变化
			onPasswordChange(val) {
				this.passwordStrength = this.checkPasswordStrength(val)
				// 根据密码强度切换标签页
				this.passwordStrengthTab = this.passwordStrength.tab || 'low'
			},

			// 处理标签页点击（禁用点击）
			handleTabClick(tab) {
				// 什么都不做，禁用点击切换
				console.log('标签页点击被禁用:', tab.name)
			},

			// 重置密码方法
			async handleResetPassword(row) {
				this.currentEditUser = row

				try {
					// 弹出确认框
					await this.$confirm(
						`本次操作会将 ${row.fullName} 在系统中的登录密码重置到初始密码，是否继续？`,
						'提示', {
							confirmButtonText: '确认重置',
							cancelButtonText: '取消',
							type: 'warning',
							confirmButtonClass: 'custom-confirm-btn',
							cancelButtonClass: 'custom-cancel-btn',
							dangerouslyUseHTMLString: false
						}
					)

					// 开始重置密码
					this.changingPassword = true

					// 调用修改密码接口，初始密码为123456
					const params = {
						userId: this.currentEditUser.id,
						newPassword: '123456' // 固定初始密码
					}

					const res = await editPwd(params)
					if (res && res.code === 200) {
						this.$message.success('本次操作已将您的密码已成功重置至初始密码，请重新登陆。')

						// 调用退出登录接口
						try {
							const logoutRes = await loginOut()
							if (logoutRes && logoutRes.code === 200) {
								// 清除本地存储
								localStorage.clear()
								sessionStorage.clear()
								// 跳转到登录页
								this.$router.push('/login')
							} else {
								this.$message.error('退出登录失败，请手动退出')
							}
						} catch (logoutError) {
							console.error('退出登录失败:', logoutError)
							// 强制跳转到登录页
							localStorage.clear()
							sessionStorage.clear()
							this.$router.push('/login')
						}
					} else {
						this.$message.error(res?.code + res?.message)
					}
				} catch (error) {
					if (error !== 'cancel') {
						console.error('重置密码失败:', error)
					}
				} finally {
					this.changingPassword = false
				}
			},

			// 计算表格高度
			calcTableHeight() {
				// 获取表格容器的高度
				const tableContainer = document.querySelector('.table-container')
				if (tableContainer) {
					const containerHeight = tableContainer.clientHeight
					// 设置表格高度为容器高度
					this.tableHeight = containerHeight
				} else {
					// 备用方案：每行高度大约为40px，15行大约600px
					// 加上表头高度大约40px
					this.tableHeight = 15 * 40 + 40
				}
			},

			// 表格行类名
			tableRowClassName({
				rowIndex
			}) {
				return rowIndex % 2 === 1 ? 'even-row' : ''
			},

			// 处理状态点击
			handleStatusClick(data) {
				if (data.id !== 1) { // 不是根节点
					this.status = data.value
					this.pagination.pageNum = 1
					this.fetchPersonList()
				}
			},

			// 处理状态变化
			handleStatusChange() {
				this.pagination.pageNum = 1
				this.fetchPersonList()
			},

			// 处理姓名点击
			handleNameClick(row) {
				this.handleView(row)
			},

			// 搜索处理
			handleSearch() {
				this.pagination.pageNum = 1
				this.fetchPersonList()
			},

			// 添加人员
			handleAddPerson() {
				if (this.$store.getters.hasPermission('system:staff:add')) {
					this.dialogMode = 'add'
					this.selectedId = null
					this.dialogVisible = true
				} else {
					this.$message.warning('您没有添加人员的权限')
				}
			},

			// 重置
			handleReset() {
				this.status = ''
				this.searchName = ''
				this.pagination.pageNum = 1
				this.fetchPersonList()
			},

			// 查看详情
			handleView(row) {
				this.dialogMode = 'view'
				this.selectedId = row.id
				this.dialogVisible = true
			},

			// 编辑
			handleEdit(row) {
				this.dialogMode = 'edit'
				this.selectedId = row.id
				this.dialogVisible = true
			},

			// 分页大小变化
			handleSizeChange(val) {
				this.pagination.pageSize = val
				this.pagination.pageNum = 1
				this.calcTableHeight() // 重新计算表格高度
				this.fetchPersonList()
			},

			// 当前页变化
			handleCurrentChange(val) {
				this.pagination.pageNum = val
				this.fetchPersonList()
			},

			// 生成随机颜色缓存
			generateColorCache() {
				this.colorCache = {}
			},

			// 获取随机颜色
			getRandomColor(id) {
				if (!id) {
					const colors = [
						'#409eff', '#67c23a', '#e6a23c', '#f56c6c',
						'#909399', '#8e44ad', '#16a085', '#d35400'
					]
					return colors[Math.floor(Math.random() * colors.length)]
				}

				// 如果已缓存，使用缓存的颜色
				if (this.colorCache[id]) {
					return this.colorCache[id]
				}

				// 根据ID生成确定性的颜色
				const colors = [
					'#409eff', '#67c23a', '#e6a23c', '#f56c6c',
					'#909399', '#8e44ad', '#16a085', '#d35400',
					'#3498db', '#e74c3c', '#2ecc71', '#f39c12',
					'#1abc9c', '#9b59b6', '#34495e', '#e67e22'
				]

				const index = id % colors.length
				const color = colors[index]
				this.colorCache[id] = color
				return color
			},

			// 更新树菜单的计数
			updateTreeCounts(data) {
				if (!data) return

				// 更新总计数
				this.departmentTree[0].count = data.totalElements || 0

				// 更新正常和异常计数
				let normalCount = 0
				let abnormalCount = 0

				if (data.content && Array.isArray(data.content)) {
					data.content.forEach(item => {
						if (item.status === 1) {
							normalCount++
						} else if (item.status === 0) {
							abnormalCount++
						}
					})
				}

				this.departmentTree[0].children[0].count = normalCount
				this.departmentTree[0].children[1].count = abnormalCount
			},

			// 获取字典数据
			async fetchDictData() {
				try {
					const res = await dict()
					if (res && res.code === 200 && res.data) {
						this.dictData = {
							natyEntities: res.data.natyEntities || [],
							profttlEntities: res.data.profttlEntities || [],
							jobEntities: res.data.jobEntities || [],
							aboTypeEntities: res.data.aboTypeEntities || []
						}
					}
				} catch (error) {
					console.error('获取字典数据失败:', error)
				}
			},

			// 获取字典文本
			getDictText(dictKey, value) {
				if (!this.dictData[dictKey] || !Array.isArray(this.dictData[dictKey])) {
					return ''
				}

				const dictArray = this.dictData[dictKey]
				const item = dictArray.find(item => item && item.id == value)
				return item ? item.name : ''
			},

			// 格式化身份证号
			formatIdNumber(idNumber) {
				if (!idNumber || typeof idNumber !== 'string') {
					return ''
				}

				if (idNumber.length < 7) {
					return idNumber
				}

				// 保留前3位和后4位，中间用*代替
				const prefix = idNumber.substring(0, 3)
				const suffix = idNumber.substring(idNumber.length - 4)
				const middle = '*'.repeat(idNumber.length - 7)

				return prefix + middle + suffix
			},

			// 对话框成功回调
			handleDialogSuccess() {
				this.dialogVisible = false
				// 重新获取人员列表
				this.fetchPersonList()
			},

			// 异步搜索建议
			async querySearchAsync(queryString, cb) {
				if (!queryString || queryString.trim() === '') {
					// 清空搜索框时，不显示建议
					this.searchSuggestions = []
					cb([])
					return
				}

				try {
					this.searchLoading = true

					const params = {
						fullName: queryString,
						pageNum: 1,
						pageSize: 10,
						status: ''
					}

					const res = await selectList(params)
					if (res && res.code === 200 && res.data && Array.isArray(res.data.content)) {
						// 提取姓名作为建议
						const suggestions = res.data.content
							.filter(item => item.fullName && item.fullName.toLowerCase().includes(queryString
								.toLowerCase()))
							.map(item => ({
								value: item.fullName,
								id: item.id
							}))
							.slice(0, 8) // 最多显示8条建议

						this.searchSuggestions = suggestions
						cb(suggestions)
					} else {
						this.searchSuggestions = []
						cb([])
					}
				} catch (error) {
					console.error('获取搜索建议失败:', error)
					this.searchSuggestions = []
					cb([])
				} finally {
					this.searchLoading = false
				}
			},

			// 处理搜索建议选择
			handleSelectSuggestion(item) {
				this.searchName = item.value
				this.pagination.pageNum = 1
				this.fetchPersonList()
			},

			// 处理清空搜索框
			handleClearSearch() {
				this.searchName = ''
				this.pagination.pageNum = 1
				this.fetchPersonList()
			},

			// 转义正则表达式特殊字符
			escapeRegExp(string) {
				return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
			}
		}
	}
</script>

<style lang="less" scoped>
	.new-acc-container {
		display: flex;
		flex-direction: column;
		height: calc(100vh - 120px);
		background-color: #f5f7fa;
		overflow: hidden;
		box-sizing: border-box;

		.main-content-area {
			flex: 1;
			display: flex;
			overflow: hidden;
			padding: 12px;

			.department-nav {
				flex-shrink: 0;
				width: 160px;
				background-color: #fff;
				border-radius: 4px;
				box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
				margin-right: 12px;
				display: flex;
				flex-direction: column;
				overflow: hidden;

				.nav-header {
					padding: 12px;
					font-weight: 600;
					color: #303133;
					border-bottom: 1px solid #e6e6e6;
					background-color: #f8f9fa;
					display: flex;
					justify-content: space-between;
					align-items: center;

					.add-btn {
						padding: 4px;
						font-size: 20px;

						&:hover {
							color: #409eff;
						}
					}
				}

				// 高亮匹配文本样式（红色加粗）
				.highlight-match-red {
					color: #f56c6c;
					font-weight: 600;
					background-color: rgba(245, 108, 108, 0.1);
					padding: 0 2px;
					border-radius: 2px;
				}

				// 当前用户标记样式
				.current-user-mark {
					font-weight: bold;
					color: #409eff;
					position: relative;
					padding-left: 8px;

					&::before {
						content: '';
						position: absolute;
						left: 0;
						top: 50%;
						transform: translateY(-50%);
						width: 3px;
						height: 16px;
						background-color: #409eff;
						border-radius: 1.5px;
					}
				}

				// 禁用添加按钮样式
				.add-btn-disabled {
					color: #c0c4cc !important;
					cursor: not-allowed;

					&:hover {
						color: #c0c4cc !important;
					}
				}

				// 表格操作列按钮样式
				.operation-buttons {
					display: flex;
					gap: 4px;
					justify-content: center;

					.el-button {
						margin: 0;
					}
				}

				// 自定义确认按钮样式
				.custom-confirm-btn {
					background-color: #f56c6c;
					border-color: #f56c6c;
					color: white;

					&:hover {
						background-color: #f78989;
						border-color: #f78989;
					}
				}

				.custom-cancel-btn {
					&:hover {
						border-color: #f56c6c;
						color: #f56c6c;
					}
				}

				/deep/ .el-tree {
					flex: 1;
					overflow-y: auto;
					padding: 8px;
					font-size: 12px;

					.el-tree-node__content {
						height: 28px;
						transition: all 0.2s;

						&:hover {
							background-color: #f5f7fa;
						}
					}

					.el-tree-node.is-current>.el-tree-node__content {
						background-color: #ecf5ff;
						color: #409eff;
					}

					.custom-tree-node {
						display: flex;
						align-items: center;
						width: 100%;

						.tree-icon {
							margin-right: 6px;
							color: #909399;
							font-size: 12px;
						}

						.dept-count {
							margin-left: auto;
							background-color: #f0f0f0;
							color: #666;
							font-size: 11px;
							padding: 1px 6px;
							border-radius: 10px;
							min-width: 20px;
							text-align: center;
						}
					}
				}
			}

			// 当前用户标记样式
			.current-user-mark {
				font-weight: bold;
				color: #409eff;
				position: relative;
				display: inline-block;
				padding-left: 8px;

				&::before {
					content: '';
					position: absolute;
					left: 0;
					top: 50%;
					transform: translateY(-50%);
					width: 3px;
					height: 16px;
					background-color: #409eff;
					border-radius: 1.5px;
				}
			}

			// 表格行样式优化
			/deep/ .el-table {
				.el-table__row {
					td:first-child {
						.cell {
							display: flex;
							align-items: center;
							justify-content: center;
						}
					}
				}
			}

			.data-table-area {
				flex: 1;
				display: flex;
				flex-direction: column;
				background-color: #fff;
				border-radius: 4px;
				box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
				overflow: hidden;

				.table-filter-area {
					flex-shrink: 0;
					padding: 12px 16px;
					border-bottom: 1px solid #e6e6e6;
					background-color: #fff;

					.filter-group {
						display: flex;
						align-items: center;
						gap: 10px;

						.filter-select {
							width: 120px;
						}

						// 修改搜索输入框样式
						.search-input {
							width: 200px;
							position: relative;

							/deep/ .highlight-match-red {
								color: #f56c6c;
							}

							&:focus-within {
								/deep/ .el-input__inner {
									border-color: #409eff;
								}
							}

							/deep/ .el-autocomplete-suggestion {
								.highlight-match-red {
									color: #f56c6c;
									font-weight: 600;
									background-color: rgba(245, 108, 108, 0.1);
									padding: 0 2px;
									border-radius: 2px;
								}
							}
						}

						// 修改按钮样式
						.el-button {
							&:focus {
								box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
							}
						}
					}
				}

				.table-container {
					flex: 1;
					overflow: hidden;
					height: calc(100% - 120px);
					/* 减去筛选区域和分页区域的高度 */

					/deep/ .el-table {
						height: 100%;

						.el-table__body-wrapper {
							overflow-y: auto;
						}

						.el-table__row.even-row {
							background-color: #fafafa;
						}

						.el-table__row:hover {
							background-color: #f5f7fa;
						}

						.name-cell {
							display: flex;
							align-items: center;
							justify-content: center;

							.avatar {
								margin-right: 8px;
								flex-shrink: 0;
							}

							.name-link {
								flex: 1;
								min-width: 60px;
								font-size: 12px;
								cursor: pointer;
								overflow: hidden;
								text-overflow: ellipsis;
								white-space: nowrap;

								&:hover {
									color: #409eff;
									text-decoration: underline;
								}
							}
						}

						.gender-cell {
							display: flex;
							align-items: center;
							justify-content: center;

							.gender-icon {
								margin-right: 4px;
								font-size: 14px;

								&.male {
									color: #409eff;
								}

								&.female {
									color: #f56c6c;
								}
							}
						}

						.el-table__cell {
							padding: 6px 0;

							// 表格内容超出显示省略号
							.cell {
								overflow: hidden;
								text-overflow: ellipsis;
								white-space: nowrap;
							}
						}

						.el-button {
							margin: 0 2px;
							padding: 6px 8px;
						}

						// 工具提示样式
						.el-tooltip {
							display: block;

							.tooltip-content {
								max-width: 300px;
								word-wrap: break-word;
								word-break: break-all;
							}
						}
					}
				}

				.pagination-area {
					flex-shrink: 0;
					padding: 12px 16px;
					border-top: 1px solid #e6e6e6;
					background-color: #fff;
					display: flex;

					&.left {
						justify-content: flex-start;
					}

					/deep/ .el-pagination {
						margin-top: 0;
					}
				}
			}
		}
	}

	// 高亮匹配文本的样式
	.highlight-match {
		color: #409eff;
		font-weight: 600;
		background-color: rgba(64, 158, 255, 0.1);
		padding: 0 2px;
		border-radius: 2px;
	}

	// 搜索建议下拉框样式
	/deep/ .el-autocomplete-suggestion {
		.el-autocomplete-suggestion__wrap {
			max-height: 280px;

			li {
				line-height: 28px;
				padding: 0 12px;
				font-size: 12px;

				&:hover {
					background-color: #f5f7fa;
				}

				.highlight-match {
					color: #409eff;
					font-weight: 600;
				}
			}
		}
	}

	// 滚动条样式
	::-webkit-scrollbar {
		width: 6px;
		height: 6px;
	}

	::-webkit-scrollbar-track {
		background: #f1f1f1;
		border-radius: 3px;
	}

	::-webkit-scrollbar-thumb {
		background: #c1c1c1;
		border-radius: 3px;

		&:hover {
			background: #a8a8a8;
		}
	}

	// 自定义tooltip样式
	/deep/ .password-tooltip-popper {
		.el-tooltip__popper {
			padding: 8px 12px;
			background-color: #fff;
			box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
			border-radius: 4px;
			border: 1px solid #ebeef5;

			.el-tooltip__content {
				line-height: 1.4;
			}
		}
	}
</style>